import PropTypes from 'prop-types'
import Button from '@mui/material/Button'
import CartOutlineIcon from 'mdi-react/CartOutlineIcon'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const BOOKS = {
  'Uzbekistan, October 2019': 'https://www.blurb.com/b/10302202-uzbekistan-october-2019'
}

function BookButton({ book, ...props }) {
  const { t } = useTranslation()

  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      href={BOOKS[book]}
      target="_blank"
      rel="noopener noreferrer"
      role="button"
      sx={{ gap: '1ch' }}
      {...props}
    >
      <CartOutlineIcon color="currentcolor" size="1em" />
      {t('postBook.buy')}
    </Button>
  )
}

BookButton.propTypes = {
  book: PropTypes.string
}

export default BookButton
